import { render, staticRenderFns } from "./GestorCentralizadoAdicionalForm.vue?vue&type=template&id=65ebc954&"
import script from "./GestorCentralizadoAdicionalForm.vue?vue&type=script&lang=js&"
export * from "./GestorCentralizadoAdicionalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports